import script from "./InputDate.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputDate.vue?vue&type=script&setup=true&lang=ts"

import "./InputDate.vue?vue&type=style&index=0&id=a4692ba4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4692ba4"]])

export default __exports__